import { createHashRouter } from "react-router-dom";

import Home from "../pages/home";
import Login from "../pages/login";
import NotFound from "../pages/notfound";
import Register from "../pages/register";
import RegisterConfirm from "../pages/registerconfirm";
import RegisterEmailSent from "../pages/registeremailsent";
import ExamStart from "../pages/examstart";
import ExamLanding from "../pages/examlanding";
import Question from "../pages/question";
import SectionComplete from "../pages/sectioncomplete";
import ExamComplete from "../pages/examcomplete";
import ExamResults from "../pages/results";
import MaxRetry from "../pages/maxretry";
import SectionEnd from "../pages/sectionend";
import Coupon from "../pages/coupon";
import RegisterPay from "../pages/pay";
import LoadError from "./error";
import Admin from "../pages/admin";
import ForgotPassword from "../pages/forgotpassword";
import CompletedExams from "../pages/completedExams";
import StartNewExam from "../pages/startNewExam";

const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/register-coupon",
    element: <Coupon />,
    errorElement: <LoadError />,
  },
  {
    path: "/register-pay",
    element: <RegisterPay />,
  },
  {
    path: "/register-confirm",
    element: <RegisterConfirm />,
  },
  {
    path: "/register-email-sent",
    element: <RegisterEmailSent />,
  },
  {
    path: "/exam-start",
    element: <ExamStart />,
  },
  {
    path: "/exam-landing",
    element: <ExamLanding />,
  },
  {
    path: "/question/:questionid",
    element: <Question />,
    errorElement: <LoadError />,
  },
  {
    path: "/section-complete",
    element: <SectionComplete />,
    errorElement: <LoadError />,
  },
  {
    path: "/exam-complete",
    element: <ExamComplete />,
  },
  {
    path: "/exam-results",
    element: <ExamResults />,
    errorElement: <LoadError />,
  },
  {
    path: "/completed-exams",
    element: <CompletedExams />,
    errorElement: <LoadError />,
  },
  {
    path: "/start-new-exam",
    element: <StartNewExam />,
    errorElement: <LoadError />,
  },
  {
    path: "/admin",
    element: <Admin />,
    errorElement: <LoadError />,
  },
  {
    path: "max-retry",
    element: <MaxRetry />,
    errorElement: <LoadError />,
  },
  {
    path: "section-end",
    element: <SectionEnd />,
    errorElement: <LoadError />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

const router = createHashRouter(routes, {
  basename: "/",
});

export default router;
